<template>
    <div id="nav">
        <ul>
            <li @click="goRecharge()"><img src="@/assets/images/nav/toolbar_recharge.png"/><span>{{$t("trade.navigate.recharge")}}</span></li>
            <li @click="goWithdrawal()"><img src="@/assets/images/nav/toolbar_withdraw.png"/><span>{{$t("trade.navigate.withdrawal")}}</span></li>
            <!-- <li @click="goKnowledge"><img src="@/assets/images/nav/toolbar_activity.png"/><span>{{$t("trade.navigate.knowledge")}}</span></li> -->
            <li @click="goTradeReport"><img src="@/assets/images/nav/toolbar_transaction.png"/><span>{{$t("trade.navigate.transaction")}}</span></li>
            <li @click="openIM"><img src="@/assets/images/nav/toolbar_online_service.png"/><span>{{$t("trade.navigate.online_service")}}</span></li>
        </ul>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    export default {
        name: "Nav",
        computed: {
            ...mapState(['locale','user'])
        },
        data(){
            return{
                wwwUrl: process.env.VUE_APP_WWW,
                lang:""
            }
        },
        methods:{
            openIM() {
                var url = `https://onlinecs.cfglobal139.com/?lang=${this.locale}&version=vntrex&company_id=30&utm_source=web&utm_terminal=1&refer=https%3A%2F%2Fwww.cfglobal139.com%2F${this.locale}%2F`
                var left = (screen.width / 2) - (800 / 2);
                var top = (screen.height / 2) - (550 / 2);
                window.open(url, "DescriptiveWindowName", "resizable,scrollbars=yes,status=1,width=800, height=550, top=" + top + ", left=" + left);
            },
            goRecharge() {
                this.$bus.$emit('loading', false);
                if (!(this.user && this.user.loginname)) {
                    this.$router.push({ path: '/login' })
                    return
                }

                this.$router.push({
                    path: '/home/nesting', query: {
                        url: `${this.wwwUrl}recharge?token=${this.user.token}&locale=${this.locale}&pageType=trade&skinType=trade1`,
                        title:this.$t("myself.recharge")
                    },
                });
            },
            goWithdrawal() {
                this.$bus.$emit('loading', false);
                if (!(this.user && this.user.loginname)) {
                    this.$router.push({ path: '/login' })
                    return
                }

                this.$router.push({
                    path: '/home/nesting', query: {
                        url: `${this.wwwUrl}withdrawal?token=${this.user.token}&locale=${this.locale}&pageType=trade&skinType=trade1`,
                        title:this.$t("myself.withdrawal")
                    },
                });
            },
            goTradeReport(){
                this.$bus.$emit('loading', false);
                if(this.user.loginname){
                    this.$router.push({
                        path: '/home/nesting', query: {
                            url: this.wwwUrl + 'tradeReport?token='+this.user.token+'&locale='+this.locale+'&pageType=trade&skinType=trade1',
                            title:this.$t("myself.tradeReport")
                        },
                    });
                }else {
                    this.$router.push({path: '/login'})
                }
            },
            goKnowledge(){
                this.$bus.$emit('loading', false);
                let type="";
                if (this.locale == "vn") {
                    type = '251'
                } else {
                    type = '261'
                }
                this.$router.push({
                    path: '/home/embed', query: {
                        url: 'https://m.forexcf.com/'+this.locale+'/cn/app/academy/knowledge.html?type='+type,
                        title:this.$t("trade.navigate.knowledge")
                    },
                });
            }
        }
    }
</script>
